import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { TypesSyncPage } from '../../../../components/TypesSyncPage'

// URL state of the comparison (spec 2026-09-25-02): the source, the family in
// view, the status filter (comma list, default all) and the search. The
// selection is component state.
// A hand-edited or stale URL must never break the page, hence `.catch`; the
// router's search parser turns `q=123` into a number, hence the union.
const text = z
  .union([z.string(), z.number()])
  .transform((v) => String(v))
  .optional()
  .catch(undefined)

const syncSearchSchema = z.object({
  source: z.enum(['template', 'defaults']).optional().catch(undefined),
  family: text,
  status: text,
  q: text,
})

export const Route = createFileRoute('/$org/types/sync/')({
  validateSearch: syncSearchSchema,
  component: TypesSyncPage,
})
